import type { StationeryTemplate } from './DesignsGallery.types';
import { useActivePrintFiltersVar } from './utils/activePrintFiltersCache';
import { useMemo } from 'react';

export const useTagFilteredTemplates = (templates: ReadonlyArray<StationeryTemplate>) => {
  const activePrintFilters = useActivePrintFiltersVar();

  return useMemo(() => {
    if (!activePrintFilters.size) return templates;

    return templates.filter(template => {
      return template.mappedTags.some(tagCompositeCode => activePrintFilters.has(tagCompositeCode));
    });
  }, [templates, activePrintFilters]);
};
